import * as t from './actionTypes';

type CampaignIndexAction = {
  type: string;
  campaignMetrics: Record<string, unknown>;
};

export type CampaignIndexState = {
  campaignMetrics: Record<string, unknown>;
  loading: boolean;
};

export const initialState: CampaignIndexState = {
  campaignMetrics: {},
  loading: false,
};

const campaignIndexReducer = (state = initialState, action: CampaignIndexAction) => {
  switch (action.type) {
    case t.GET_CAMPAIGN_METRICS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case t.GET_CAMPAIGN_METRICS_RESPONSE:
      return {
        ...state,
        campaignMetrics: {
          ...state.campaignMetrics,
          ...action.campaignMetrics,
        },
        loading: false,
      };
    default: {
      return state;
    }
  }
};

export default campaignIndexReducer;
